import React from "react";
import Accordion from "../Components/Accordion/Accordion";
import "../Styles/faq.css";

const FAQ = () => {
  return (
    <div className="faq mx-auto">
      <p className="fs-1 fw-bold text-center">F.A.Q</p>
      <Accordion />
    </div>
  );
};

export default FAQ;
